import React from "react";
import Forms from "@/pages/Forms";

// Owner forms reuses the standard Forms catalog. Wrapping for route consistency.
export default function OwnerForms() {
  return <Forms />;
}
